import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_GRAVITY_STRENGTH, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { useDispatch } from "react-redux";
import { Control } from "../../../../control/control";
import { Range } from "../../../../range/range";
import { setGravityStrength } from "../../../../../features/config/config.slice";
export const SnowflakeGravityStrength = ({ index, layer, }) => {
    const dispatch = useDispatch();
    return (_jsx(Control, { name: "Strength", tooltip: "The strength of the force of gravity", showOutput: true, reset: () => {
            const strength = index < DEFAULT_LAYERS.length ? DEFAULT_LAYERS[index].gravity.strength : DEFAULT_GRAVITY_STRENGTH;
            dispatch(setGravityStrength({
                index,
                strength
            }));
        }, value: layer.gravity.strength, onChange: (event) => dispatch(setGravityStrength({
            index,
            strength: Number(event.target.value),
        })), children: _jsx(Range, { min: "0", max: "5", step: "0.1" }) }));
};
